// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"191":"4855356a","279":"80472b94"}[chunkId] + ".js";
};